'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFlag = function IoIosFlag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 8.8c0.4-0.1 0.8-0.1 1.2-0.2v13.5c-0.4 0.1-0.8 0.1-1.2 0.2-0.9 0-1.9 0.2-3.1 0.2-1.9 0-3.7-0.3-5.4-0.7s-3.3-1-5-1c-2.3 0-3.6 0.4-4.1 0.5v11.2h-1.2v-23.9l0.2-0.2c0.2-0.1 1.4-0.9 5.1-0.9 1.9 0 3.5 0.3 5.2 0.7 1.7 0.3 3.3 0.9 5.1 0.9 1.2 0 2.3-0.3 3.1-0.3z' })
        )
    );
};

exports.default = IoIosFlag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-flag.js
// module id = 2392
// module chunks = 0